import { useNavigate } from "react-router-dom";
import { Star, ChevronRight } from "lucide-react";
import AppIcon from "@/components/AppIcon";

export default function ProstoAppRow({ app }) {
  const navigate = useNavigate();
  const go = () => navigate(`/prosto/app/${app.id}`);
  return (
    <div
      data-testid={`prosto-app-row-${app.id}`}
      onClick={go}
      className="flex items-center gap-3 py-3 cursor-pointer active:opacity-70 transition"
    >
      <AppIcon src={app.icon} alt={app.name} size={56} className="rounded-[14px] border border-slate-200" />
      <div className="min-w-0 flex-1">
        <div className="text-[15px] font-semibold text-slate-900 leading-tight truncate">{app.name}</div>
        <div className="text-xs text-slate-500 truncate">{app.subtitle || app.category}</div>
        <div className="mt-1 flex items-center gap-1 text-[11px] text-slate-400">
          <Star size={11} className="fill-amber-400 text-amber-400" />
          <span className="text-slate-500">{app.rating}</span>
          <span className="text-slate-300">· {app.ratings_count}</span>
        </div>
      </div>
      <button
        data-testid={`prosto-app-get-${app.id}`}
        onClick={(e) => {
          e.stopPropagation();
          go();
        }}
        className="shrink-0 px-4 py-1.5 rounded-full text-sm font-semibold bg-[#2F6BFF] text-white active:scale-95 transition"
      >
        Получить
      </button>
    </div>
  );
}
